export default "__VITE_ASSET__CErss5Gf__"